import { Component, Input,Output, EventEmitter, OnInit } from '@angular/core';
import { ISetup } from '../../models/setup.interface';
import { ERoleAdminString } from '../../../../shared/data/role.enum';

@Component({
  selector: 'app-list-setups',
  templateUrl: './list-setups.component.html',
  styleUrls: ['./list-setups.component.scss']
})
export class ListSetupsComponent implements OnInit {
  ERoleAdminString = ERoleAdminString;
  @Input() setups: ISetup[] = [];
  @Output() mudouTamanhoPagina = new EventEmitter<number>();
  @Output() mudouPagina = new EventEmitter<number>();
  @Input() dadosPaginacao: {
    paginaSelecionada: number;
    tamanhoPagina: number;
    totalPaginas: number;
    itensTotal: number;
  } = {
      paginaSelecionada: 0,
      tamanhoPagina: 10,
      totalPaginas: 0,
      itensTotal: 0
    };

  constructor() { }

  ngOnInit(): void {
  }

}
